<template>
  <div>
    <footer class="footer-wrapper" :class="{'centered': !showSubmit}">
      <div
        type="danger"
        size="mini"
        @click="skip()"
        class="button-skip delay-entry skip unselectable"
        :class="{'skip-selected': skipped, 'align-left': showSubmit}"
        :disabled="disabled"
      >Saltar pregunta</div>
      <el-button
        type="danger"
        @click="submit()"
        class="submit-button"
        v-if="showSubmit"
        :disabled="disableSubmitButton"
      >Enviar</el-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SkipQuestionButton',

  props: [ 'disabled', 'alignLeft', 'disableSubmitButton', 'showSubmit' ],

  data () {
    return {
      skipped: false
    }
  },

  methods: {
    skip () {
      this.skipped = true
      this.$emit('skip')
    },
    submit () {
      this.$emit('submit')
    }
  }

}
</script>

<style scoped lang="scss">
  footer {
    position: relative;
    width: calc(160vw * (9/16));
    margin: 10px auto;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &.centered {
      justify-content: center;
    }

    @include breakpoint($tablet) {
      width: calc(130vw * (9/16));
      margin-bottom: 2em;
    }
    @include breakpoint($desktop) {
      width: 460px;
    }
  }

  .button-skip {
    line-height: 1;
    height: 1.2em;
    background: none;
    color: $gray-dark;
    border: none;
    border-bottom: 1px solid $gray-dark;
    transition: all 0.1s ease-in-out;
    z-index: 0;
    position: relative;

    @include breakpoint($micro) {
      font-size: 0.9em;
    }
    &.skip-selected {
      font-size: 1.1em;
      border-bottom: 1px solid #fff;
      color: $gray-medium;
    }
  }

  .submit-button {
    z-index: 1;
    position: relative;
    @include breakpoint($micro) {
      padding: 5px;
    }
  }

  @keyframes standOut {
    0% { transform: scale(0.99); opacity: 0; }
    20% { transform: scale(1.15) }
    100% { transform: scale(1.05); opacity: 1; }
  }
</style>
